interface Props {
  pathname: string;
}

export function addSvg(props: Props) {
  return (
<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="26" height="26" rx="4.5" stroke="#1F7DFF"/>
<rect x="13" y="5" width="2" height="18" rx="1" fill="#1F7DFF"/>
<rect x="5" y="15" width="2" height="18" rx="1" transform="rotate(-90 5 15)" fill="#1F7DFF"/>
</svg>
)
}
